import * as lottie from "lottie-web";

const animationData = require(`../../animations/loader.json`);
jQuery.fn.extend({
    loader: function (show) {

        let animation = this.data('loader');
        if (!animation && show) {
            this.data('content', this.html());
            animation = lottie.default.loadAnimation({
                container: this.get(0),
                animationData,
                renderer: 'svg',
                loop: true,
                autoplay: false,
                name: 'loader',
                rendererSettings: {
                    className: 'sport1-loader medium'
                }
            });
        }

        if (animation) {
            if (show) {
                this.data('loader', animation);
                animation.play();
            } else {
                animation.stop();
                animation.destroy();
                this.data('loader', null);
                this.html(this.data('content'));
            }
        }
    }
});


jQuery.fn.extend({
    isOnScreen: function () {
        const elem = this;
        if (elem.length === 0) {
            return;
        }
        let $window = jQuery(window)
        let viewport_top = $window.scrollTop()
        let viewport_height = $window.height()
        let viewport_bottom = viewport_top + viewport_height
        let $elem = jQuery(elem)
        let top = $elem.offset().top
        let height = $elem.height()
        let bottom = top + height

        return (top >= viewport_top && top < viewport_bottom) ||
            (bottom > viewport_top && bottom <= viewport_bottom) ||
            (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
    }
});
